import { gql } from '@apollo/client';

export const getRangeHistoryQuery = gql`
    query GetRangeHistory($start: DateTimeISO!, $end: DateTimeISO!) {
        eventLogs(
            createdAtStart: $start, 
            createdAtEnd: $end, 
            type: [QuestCompleted, QuestMetricIncreased]
        ) 
        {
            id
            eventType
            timeOfDay
            createdAt
            questMetricIncreased {
                questId
                addedValue
                questMetricType
            }
        }
    }
`;